import { ProductColors } from '../../../../tokens/colors/types';

export const deals: ProductColors['deals'] = {
  '30': '#DA3835',
  '40': '#F9700D',
};
